import { render, staticRenderFns } from "./ClicGeolocation.vue?vue&type=template&id=6f80edc8&"
import script from "./ClicGeolocation.vue?vue&type=script&lang=js&"
export * from "./ClicGeolocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports